import { invoicingAgent } from "../../app/api/agent";
import { ProgramTypeDeliverableDto } from "./dtos/ProgramTypeDeliverableDto";

export const getProgramTypeDeliverablesRequest = () =>
  invoicingAgent.getRequest<ProgramTypeDeliverableDto[]>(
    "/programTypeDeliverables",
    {},
    true
  );
